import { memo } from 'react';
import type { StandoutQuote as StandoutQuoteRecord } from '../../../../../fsm/jobs';
import { dimensionLabel } from '../../../utils/dimensions';
import styles from './index.module.css';

export interface StandoutQuoteProps {
  /** avrio-rio's standout quote, chosen at completion. Null or absent before then. */
  quote?: StandoutQuoteRecord | null;
}

export const hasStandoutQuote = (quote?: StandoutQuoteRecord | null): boolean =>
  Boolean(quote?.quote?.trim());

/** The area the quoted answer was scored in, named as the scorecard above names it ("Work content"). */
const areaName = (dimension: string): string =>
  dimension && dimension !== 'other'
    ? dimensionLabel(dimension).toLowerCase()
    : 'another area';

/**
 * The candidate brief's standout quote (Rio PRD 5.7): one passage of the
 * candidate's own words, so a hiring manager hears them before the interview.
 * Rio chooses it from an answer it scored as clear evidence (avrio-rio,
 * agents/interview/standout_quote.py) and copies it; nothing here or there
 * rewords it, which is why it carries quotation marks and no AI mark.
 */
export const StandoutQuote = memo(({ quote }: StandoutQuoteProps) => {
  if (!quote || !hasStandoutQuote(quote)) return null;
  return (
    <figure className={styles.figure}>
      <blockquote className={styles.quote}>
        &ldquo;{quote.quote.trim()}&rdquo;
      </blockquote>
      <figcaption className={styles.caption}>
        From their answer on {areaName(quote.dimension)}
      </figcaption>
    </figure>
  );
});

StandoutQuote.displayName = 'StandoutQuote';

export default StandoutQuote;
